import React, { useCallback, useMemo } from 'react';
import { Form } from 'react-final-form';
import { Stack } from '@mui/material';

import { Button, InfoDialog } from '@occc/ui-design-system';
import { TextField } from '@occc-app/design-system';
import { useCreateMembershipCommentMutation } from '@occc/graphql';

import { CreateCommentFormValues, CreateCommentModalProps } from './create-comment-modal.types';
import { CreateCommentFormValuesValidation } from './create-comment-modal.validation';

export const CreateCommentModal = (props: CreateCommentModalProps) => {
  const { isOpen, onClose, customerUuid } = props;
  const initialValues = useMemo<CreateCommentFormValues>(() => ({ text: '' }), []);

  const [createComment] = useCreateMembershipCommentMutation({
    refetchQueries: ['membershipComments'],
    onCompleted: onClose,
  });

  const handleSubmit = useCallback(
    async (values: CreateCommentFormValues) =>
      createComment({ variables: { input: { customerUuid, text: values.text } } }),
    [createComment, customerUuid],
  );

  return (
    <InfoDialog dialogTitle='Add a Comment' onClose={onClose} open={isOpen} fullWidth>
      <Form<CreateCommentFormValues>
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validate={CreateCommentFormValuesValidation}
        render={(props) => (
          <Stack spacing={2} component='form' onSubmit={props.handleSubmit}>
            <TextField name='text' label='Your Comment' multiline={true} rows={6} />
            <Stack direction='row' spacing={2} justifyContent='flex-end'>
              <Button variant='outlined' onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant='contained'
                color='primary'
                type='submit'
                disabled={props.submitting || props.pristine || props.invalid}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        )}
      />
    </InfoDialog>
  );
};
